import { Avatar, Space, Typography, Dropdown } from "antd";
import React, { useState } from "react";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";

//
//component
//redux
//selector
//actions
// import { logOut as logOutBailiff } from "store/bailiff/auth/bailiff_auth.action";
// import { logOut as logOutUser } from "store/user/auth/user_auth.action";
import { emailSelector } from "store/user/auth/user_auth.selector";
//utils
//hook
//str
import "./header_user.css";
import { silentLogout } from "store/bailiff/login/login.action";

const HeaderUser = () => {
  // -------------------------- VAR -----------------------------

  // -------------------------- STATE ---------------------------
  const [open, setOpen] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const email = useSelector(emailSelector);
  const name = email?.split("@")?.[0] || "New Account";

  // -------------------------- FUNCTION ------------------------
  const handleLogout = () => {
    dispatch(silentLogout());
  };

  const handleChange = (value) => {
    setOpen(value);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const items = [
    {
      key: "1",
      label: (
        <Space onClick={handleLogout}>
          <LogoutOutlined />
          <Typography.Text>Đăng Xuất</Typography.Text>
        </Space>
      ),
    },
  ];

  // -------------------------- MAIN ----------------------------
  return (
    <Dropdown
      menu={{ items }}
      placement="bottom"
      trigger={["hover"]}
      open={open}
      onOpenChange={handleChange}
      className="logout-dropdown"
    >
      <div
        style={{
          width: 150,
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
        }}
      >
        <Avatar size="small" icon={<UserOutlined />} />
        <Typography.Text
          style={{ marginLeft: 10, width: 100 }}
          ellipsis={{ rows: 1 }}
          type="secondary"
        >
          {name}
        </Typography.Text>
      </div>
    </Dropdown>
  );
};
export default HeaderUser;
